module.exports = "<div [formGroup]=\"formGroup\" class=\"textarea-view\">\n  <textarea name=\"name\" [formControlName]=\"textareaPrompt.key\" [rows]=\"textareaPrompt.rows\" [attr.disabled]=\"formGroup.disabled ? 'disabled': null\">{{textareaPrompt.value}}</textarea>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/text-views/textarea-view/textarea-view.html
// module id = RZKT
// module chunks = 3